import { SchoolAgenda } from './../../../models/school-agenda';
import { Client } from './../../../models/client';
import { School } from './../../../models/school';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';
declare const google: any;

@Component({
  selector: 'app-school-add',
  templateUrl: './school-add.component.html',
  styleUrls: ['./school-add.component.css']
})
export class SchoolAddComponent implements OnInit {

  school: School;
  clients: any[];
  cityWeathers: any[];
  map: any;
  packType: any = '3';
  schoolMarker: any;
  public clientsData: Array<Select2OptionData>;
  public cityWeatherData: Array<Select2OptionData>;
  pnotify = undefined;
  // ----- Start Ion Range Slider -----------
  ion_min = moment('0000', 'hmm').format('X');
  ion_max = moment('2359', 'hmm').format('X');
  ion_from = moment('0000', 'hmm').format('X');
  ion_to = moment('2359', 'hmm').format('X');
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------

  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    pnotifyService: PNotifyService
  ) {
    this.school = new School();

    this.http.get(
      '/api/client/lookup'
    ).subscribe((clients: any[]) => {
      this.clients = clients;
      this.clientsData = this.clients.map(function (client, index) {
        return { id: client.id, text: client.name };
      });
    });
    this.http.get(
      '/api/cityWeather/lookup'
    ).subscribe((cityWeathers: any[]) => {
      this.cityWeathers = cityWeathers;
      this.cityWeatherData = this.cityWeathers.map(function (cityWeather, index) {
        return { id: cityWeather.id, text: cityWeather.cityName };
      });
    });
    this.pnotify = pnotifyService.getPNotify();
  }

  clientChanged(e: any) {
    this.school.clientId = e.value;
    const selectedClient = this.clients.find(client => {
      return client.id == e.value;
    });

    // Check if the client is found and has a packType property
    if (selectedClient) {
      this.packType = selectedClient.pack;
    } else {
      this.packType = '3';
    }
  }

  cityWeatherChanged(e: any) {
    this.school.cityWeatherId = e.value;
  }

  ngOnInit() {
    this.initMap();
  }

  initMap() {
    const pos = { lat: 31.585832, lng: -6.183891 };
    let option = {
      center: pos,
      zoom: 6,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    this.map = new google.maps.Map(document.getElementById('map'), option);
    google.maps.event.addListener(this.map, 'click', (event) => {
      this.placeMarker(event);
    });
  }

  placeMarker(event) {
    if (!this.schoolMarker){
      this.schoolMarker = new google.maps.Marker({
        position: event.latLng,
        map: this.map,
        icon: 'assets/images/markers/school.png',
        draggable: true,
        zIndex: 100,
      });
      this.school.lat = event.latLng.lat();
      this.school.lng = event.latLng.lng();
      google.maps.event.addListener(this.schoolMarker, 'dragend', (e) => {
        this.school.lat = e.latLng.lat();
        this.school.lng = e.latLng.lng();
      });
    }
  }

  onDateChange(event) {

    //console.log ("event : ",event.year());
    const selectedYear = event.year();
    const subscriptionYear = `${selectedYear}/${selectedYear + 1}`;

    // Update the school subscription year
    this.school.subscriptionSchoolYear = subscriptionYear;
  }

  onSubmit(): void {
    this.http.post(
      '/api/school/0',
      {
        school: this.school,
      }
    ).subscribe(
      (school: School) => {
        this.school = school;
        this.router.navigate(['/school/view', this.school.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/school/school-add/school-add.component.ts